import React, { FC } from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { InjectedIntlProps } from '../../../../../doctrine.types';

type Props = InjectedIntlProps & {
  value: string;
  hasError: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

const daysInMonth = Array.from({ length: 31 }, (x, i) => i + 1);

export const RawDecisionUploadDayField: FC<Props> = ({
  value,
  hasError,
  onChange,
  intl,
}) => {
  return (
    <select
      value={value}
      className={classNames(hasError && 'is-invalid-input')}
      name="day"
      onChange={onChange}
    >
      <option disabled value="">
        {intl.formatMessage({
          id: 'upload/decision-upload/components/DecisionUploadDayField.tsx/1',
        })}
      </option>
      {daysInMonth.map(day => (
        <option key={day} value={day}>
          {day}
        </option>
      ))}
    </select>
  );
};

export const DecisionUploadDayField = injectIntl(RawDecisionUploadDayField);
